<template>
  <div
    class="educator"
    :class="{ right: direction == 'right', left: direction == 'left' }"
  >
    <div class="educator-image">
      <img :src="educator.image" />
    </div>
    <div ref="eduContent" class="educator-content">
      <div class="quote">
        <p>{{ educator.testimony }}</p>
      </div>
      <div class="reference">
        <h2>{{ educator.name }}</h2>
        <p class="profession">{{ educator.profession }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Educator",
  props: {
    educator: {
      type: Object,
    },
    direction: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/styles.scss";

.educator {
  width: 80%;
  margin: 3em auto;
  background: #fff;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  font-size: 0.58em;
  display: flex;
  flex-direction: column;
  &-image {
    img {
      border-radius: 8px 8px 0 0;
    }
    .radius {
      border-radius: 8px;
    }
  }
  &-content {
    padding: 2.5em 2em;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-style: italic;
    h2 {
      font-size: 1.625em;
      padding: 0.5em 0;
      letter-spacing: 1.15px;
    }
    .profession {
      color: #e95557;
      font-size: 1.375em;
      font-weight: 400;
      letter-spacing: 1.15px;
    }
    .quote {
      p {
        font-size: 1.75em;
        line-height: 25px;
        letter-spacing: 0;
        padding-bottom: 2em;
      }
    }
  }
}

@include media(">=tablet") {
  .educator {
    display: flex;
    max-width: 1150px;
    max-height: 378px;
    width: 100%;
    font-size: 1em;
    &-image {
      img {
        max-height: 382px;
        max-width: 378px;
      }
    }
    &-content {
      padding: 2.9em;
      p {
      }
      .quote {
        p {
          padding-bottom: 0;
          line-height: 40px;
        }
      }
    }
  }
  .right {
    flex-direction: row-reverse;
    margin-right: 0;
    img {
      border-radius: 0 8px 8px 0;
    }
  }
  .left {
    flex-direction: row;
    margin-left: 0;
    img {
      border-radius: 8px 0 0 8px;
    }
  }
}

@include media("<desktop-md", ">=tablet") {
  .educator {
    font-size: 1.3vw;
    &-content {
      .quote {
        p {
          line-height: 4vw;
        }
      }
    }
  }
}
</style>